export class CadastroModel {
    nome: string;
    crm: string;
    estado: string;
    especialidade: string;
    interesse: string;
    endereco: string;
    telefone: string; 
    email: string;
    senha: string;
    opcao_contato: string;
    especialidades: Array<String>
    interesses: Array<String>
    opcoes_contato: Array<string>
    estados: Array<string>
    foto: string
}


// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.modelview.ts